import { createFileRoute } from '@tanstack/react-router';

import { NewLocationPage } from '../modules/locations/ui/pages/NewLocationPage';

export const Route = createFileRoute('/_authenticated/dashboard/locations/new')({
  component: NewLocationPage,
  staticData: {
    breadcrumb: ['Manage', 'Locations', 'New'],
  },
});
